export default "__VITE_ASSET__a308ac6c__"